import { Injectable } from '@angular/core';
import { Payment } from '../../models/payment';
import { ApiClient } from '../api.client';
import { getQueryStringFromObject } from '../helpers/getQueryStringFromObject';

@Injectable()
export class PaymentService {
  constructor(private http: ApiClient) {}

  create(paymentableType, paymentableId, attributes) {
    return this.http.post<Payment>(
      `${paymentableType}/${paymentableId}/payment`,
      attributes
    );
  }

  delete(paymentableId, paymentId, paymentable = 'docket') {
    return this.http.delete(
      `${paymentable}/${paymentableId}/payment/${paymentId}`
    );
  }

  generateReport(qsArgs, criteria) {
    const qs = getQueryStringFromObject(qsArgs);
    return this.http.post<any[]>(`payments/report?${qs}`, criteria);
  }

  generateReportXls(params, criteria) {
    const qs = getQueryStringFromObject(params);
    return this.http.post<any[]>(`payments/report?${qs}`, criteria, {
      responseType: 'blob'
    });
  }
}
